import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Code } from './Code';

interface IViewLicenseDialogProps {
    licenseFileElement?: React.JSX.Element;
    close: () => void;
}

const useStyles = makeStyles({
    displayCode: {
        width: '710px',
        maxWidth: '710px',
    },
});

const ViewLicenseDialog = (props: IViewLicenseDialogProps) => {
    const styles = useStyles();

    if (!props.licenseFileElement) return null;

    return (
        <Dialog open={!!props.licenseFileElement}>
            <DialogSurface className={styles.displayCode}>
                <DialogBody>
                    <DialogContent>
                        <Code text={props.licenseFileElement.props['data-text']} preserveLineBreaks={true} />
                    </DialogContent>
                    <DialogActions>
                        {props.licenseFileElement}
                        <Button appearance="secondary" onClick={props.close}>Close</Button>
                    </DialogActions>
                </DialogBody>
            </DialogSurface>
        </Dialog>
    );
};

export { ViewLicenseDialog };